import React from 'react';
import { Form as OmiliaForm } from '@omilia/chat-ui';
import { SFormContainer } from './styled';
import { useAutocomplete } from './useAutocomplete';
import { mapValues, pickBy } from 'lodash';
import { Option } from 'types';

export type Field = {
  autocomplete_enabled?: boolean;
  type: 'INPUT' | 'DROPDOWN';
  label: string;
  value?: Option;
  error_message?: string;
  required: boolean;
  id: string;
};

type FormProps = {
  fields: Field[];
  label?: string;
  submitButtonLabel?: string;
  onSubmit: (formData: any) => void;
};

const Form = ({ fields, label, submitButtonLabel, onSubmit }: FormProps) => {
  const { defaultOptions, onLoadAutocompleteOptions } = useAutocomplete();

  const getFormValue = (formData: any) => {
    const values = mapValues(formData, item =>
      typeof item === 'string' ? item : item?.value,
    );

    return pickBy(
      values,
      value => value !== undefined && value !== null && value !== '',
    );
  };

  return (
    <SFormContainer onClick={e => e.stopPropagation()}>
      <OmiliaForm
        label={label}
        submitButtonLabel={submitButtonLabel}
        fields={fields}
        onSubmit={formData => onSubmit(getFormValue(formData))}
        loadOptions={onLoadAutocompleteOptions}
        defaultOptions={defaultOptions}
      />
    </SFormContainer>
  );
};
export default Form;
